var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationsJunxure2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "224.949 109.631 271.254 155.075",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M234.72,252.49H230l10.11-29.27H246l10,29.27h-4.86l-2.36-7.22H237ZM238.79,240l-.52,1.44h9.45l-.53-1.44c-1.05-3.41-2-6.3-2.75-8.53s-1.18-3.67-1.32-4.2l-.26-.79c-.13,1.32-1.57,5.91-4.07,13.52",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,252.49h-4.33v-3.28a7.42,7.42,0,0,1-6.69,3.67,8,8,0,0,1-6.82-3.28,12,12,0,0,1-2.5-7.87,12.47,12.47,0,0,1,2.63-8.27,8.26,8.26,0,0,1,6.82-3.15,7.42,7.42,0,0,1,6.69,3.67V221.65h4.33ZM261,241.6a8.69,8.69,0,0,0,1.58,5.38,5,5,0,0,0,4.07,2.1,5.36,5.36,0,0,0,4.2-2,8.39,8.39,0,0,0,1.7-5.78,7.89,7.89,0,0,0-1.84-5.64,5.38,5.38,0,0,0-4.06-1.84,5.17,5.17,0,0,0-4.2,2A9.78,9.78,0,0,0,261,241.6",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.6,252.49h-4.85l-7.88-22.05h4.46l3,9.32c.66,2.1,1.31,4.07,1.71,5.51s.79,2.63.92,3l.13.79a85.16,85.16,0,0,1,2.89-9.45l3.14-9.32h4.47Z",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.53,223.62a2.36,2.36,0,0,1-.79,1.83,2.69,2.69,0,0,1-4.59-1.83,2.86,2.86,0,0,1,.79-2,2.56,2.56,0,0,1,1.84-.79,2.7,2.7,0,0,1,2.75,2.76M309,252.49h-4.33V230.31H309Z",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,246.45a5.57,5.57,0,0,1-2.1,4.73,9,9,0,0,1-5.65,1.7,14.33,14.33,0,0,1-6.56-1.31V247.5a11.79,11.79,0,0,0,6.3,1.84,4.54,4.54,0,0,0,2.62-.66,2,2,0,0,0,.92-1.83,2.12,2.12,0,0,0-.78-1.71,6.4,6.4,0,0,0-1.45-1.18c-.52-.26-1.44-.66-2.62-1.18-3.55-1.45-5.25-3.55-5.25-6.3a5.29,5.29,0,0,1,2.23-4.6,9.13,9.13,0,0,1,5.51-1.7,13.79,13.79,0,0,1,5.65.92V235a11.52,11.52,0,0,0-5.52-1.31,4.16,4.16,0,0,0-2.49.66,2.3,2.3,0,0,0-.92,1.83,1.19,1.19,0,0,0,.13.66.69.69,0,0,0,.27.53.68.68,0,0,1,.26.52,1.79,1.79,0,0,0,.52.39,2.27,2.27,0,0,1,.53.4c.26.13.39.26.65.39l.66.27.79.39a1.85,1.85,0,0,0,.78.26,16.6,16.6,0,0,1,4.07,2.63,5.13,5.13,0,0,1,1.45,3.8",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.64,233.2a12.23,12.23,0,0,1,2.76,8.13,11.4,11.4,0,0,1-2.76,8.14,10.93,10.93,0,0,1-15.35,0,11.91,11.91,0,0,1-2.76-8,12,12,0,0,1,2.89-8.26,9.3,9.3,0,0,1,7.61-3.28,10.65,10.65,0,0,1,7.61,3.28m-13.78,8.26a10,10,0,0,0,1.58,5.52,5.51,5.51,0,0,0,7.74,1.18,4,4,0,0,0,1.05-1,10,10,0,0,0,1.57-5.51,9.61,9.61,0,0,0-1.44-5.65,5.28,5.28,0,0,0-4.59-2.23,5.18,5.18,0,0,0-4.46,2.23,9.94,9.94,0,0,0-1.45,5.51",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.75,252.49h-4.2V230.31h4.2v3.94a5.78,5.78,0,0,1,5.77-4.07,4.49,4.49,0,0,1,1.31.13v4.2a5.46,5.46,0,0,0-2.1-.39,4.54,4.54,0,0,0-3.67,2,8.29,8.29,0,0,0-1.45,4.6Z",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.23 252.49 370.3 252.49 370.3 223.09 386.96 223.09 386.96 226.77 374.76 226.77 374.76 235.82 385.65 235.82 385.65 239.5 374.76 239.5 374.76 248.55 387.23 248.55 387.23 252.49",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.72,252.49h-4.2v-14a5.09,5.09,0,0,0-1.18-3.55,3.89,3.89,0,0,0-3-1.18,5.24,5.24,0,0,0-3.94,1.71,6.91,6.91,0,0,0-1.57,5v12h-4.2V230.31h4.2v3.81a6.88,6.88,0,0,1,6.82-4.07,7.08,7.08,0,0,1,5.25,2,8.11,8.11,0,0,1,2,5.51Z",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.21,251.44c0,3.54-1,6.17-3,8a10.92,10.92,0,0,1-7.74,2.63,16.21,16.21,0,0,1-7.48-1.44v-4.47a12.16,12.16,0,0,0,7.08,1.84q6.7,0,6.7-6.69V249a7.3,7.3,0,0,1-6.7,3.67,9.23,9.23,0,0,1-6.69-2.89,10.84,10.84,0,0,1-2.76-8.13,13.05,13.05,0,0,1,2.63-8.4,8.64,8.64,0,0,1,6.82-3.15,7.29,7.29,0,0,1,6.7,3.93v-3.67h4.46Zm-15.88-9.84a7.69,7.69,0,0,0,1.71,5.51A4.91,4.91,0,0,0,424,249a5.38,5.38,0,0,0,4.07-1.84,7.37,7.37,0,0,0,1.71-5.12,9.08,9.08,0,0,0-1.71-6,5.3,5.3,0,0,0-4.07-2,5.12,5.12,0,0,0-4.2,2.1,9,9,0,0,0-1.44,5.52",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.05,223.62a2.36,2.36,0,0,1-.79,1.83,2.69,2.69,0,0,1-4.59-1.83,2.86,2.86,0,0,1,.79-2,2.56,2.56,0,0,1,1.84-.79,2.7,2.7,0,0,1,2.75,2.76m-.52,28.87H439.2V230.31h4.33Z",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.15,252.49H463v-14a4.52,4.52,0,0,0-1.18-3.55,3.89,3.89,0,0,0-3-1.18,5.71,5.71,0,0,0-3.94,1.71,6.91,6.91,0,0,0-1.57,5v12H449V230.31h4.2v3.81a6.89,6.89,0,0,1,6.82-4.07,7.08,7.08,0,0,1,5.25,2,8.06,8.06,0,0,1,2,5.51Z",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.54,251.31a13.59,13.59,0,0,1-6.43,1.44A10.44,10.44,0,0,1,471,243V241.6a11.71,11.71,0,0,1,2.75-8.27,9.25,9.25,0,0,1,7.09-3,8.54,8.54,0,0,1,6.69,2.62,10.71,10.71,0,0,1,2.5,7.62,24,24,0,0,1-.27,2.88H475.29a6,6,0,0,0,2.49,4.33,8.74,8.74,0,0,0,5.12,1.58,9.44,9.44,0,0,0,5.9-1.71v3.68Zm-7.74-17.72a5.27,5.27,0,0,0-3.81,1.57,7.73,7.73,0,0,0-2,4.6h10.64v-.66a6.22,6.22,0,0,0-1.32-3.94,4.49,4.49,0,0,0-3.54-1.57",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.62 195.71 357.43 195.71 366.43 183.5 424.62 183.5 424.62 195.71",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.62 162.92 357.43 162.92 366.43 150.7 424.62 150.7 424.62 162.92",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.62 130.13 387.01 130.13 377.04 117.91 424.62 117.91 424.62 130.13",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.11 131.41 364.5 117.91 350.03 117.91 350.03 118.23 350.03 117.91 295.38 195.71 312.1 195.71 356.79 131.74 356.79 131.41 375.11 131.41",
    style: {
      fill: "#272157"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsJunxure2);
export default __webpack_public_path__ + "static/media/integrationsJunxure2.7635cbc2da81b108ad4fc6f51e4a2759.svg";
export { ForwardRef as ReactComponent };